import { wizardWatchers } from 'platform-components';
import { awardsSagasWatcher } from 'platform-components/src/components/awards/saga';
import { notificationsSagasWatcher } from 'platform-components/src/components/notifications/saga';
import { quizWatcher } from 'platform-components/src/components/quiz/saga';
import { all } from 'redux-saga/effects';

import { certificateModalSagasWatcher } from 'common.components/certificate-modal/saga';
import { certificatesWatcher } from 'common.components/certificates/saga';
import { classesSagasWatcher } from 'common.components/classes/saga';
import { copyLessonSagaWatcher } from 'common.components/copy-lesson-modal/saga';
import { assignmentSagasWatcher } from 'common.components/lesson-view.assignment/saga';
import { lessonViewSagasWatcher } from 'common.components/lesson-view.store/saga';
import { lessonViewSubscriptionModalSaga } from 'common.components/lesson-view.subscription-modal/saga';
import { deleteLessonSagasWatcher, lessonSagasWatcher } from 'common.components/lesson/sagas';
import { acceptPersonalDataWatcher } from 'common.components/personal-data-modal/saga';
import { resultsSagasWatcher } from 'common.components/results/saga';
import { schoolFormSagasWatcher } from 'common.components/school-form/saga';
import { studentsSagasWatcher } from 'common.components/students/saga';
import { teamBuilderSagasWatcher } from 'common.components/team-builder/saga';
import { userSagasWatcher } from 'common.components/user/saga';
import { courseContainerWidgetSagasWatcher } from 'common.components/widgets.course-container/saga';
import { clessonsSagasWatcher } from 'store/clessons/saga';
import { courseStatsSagasWatcher } from 'store/course-stats/saga';
import { coursesTemplatesSagasWatcher } from 'store/courses-templates/saga';
import { coursesBySubjectsSagasWatcher } from 'store/courses/saga';
import { diagnosticsSagasWatcher } from 'store/diagnostics/saga';
import { externalLmsSagasWatcher } from 'store/external-lms-connect/saga';
import { likesSagasWatcher } from 'store/likes/saga';
import { prepLessonsSagasWatcher } from 'store/prep-lessons/saga';
import { problemsViewSagasWatcher } from 'store/problems-view/saga';
import { problemsSagasWatcher } from 'store/problems/saga';
import { referralCodeSagasWatcher } from 'store/referral-code/saga';
import { stickersSagasWatcher } from 'store/stickers/saga';
import { studentCLessonResultsSagaWatcher } from 'store/student-clesson-result/saga';
import { subscriptionsSagasWatcher } from 'store/subscriptions/saga';
import { teacherCoursesByClassSagasWatcher } from 'store/teacher-courses/saga';
import { themesSagasWatcher } from 'store/themes/saga';

import { classSagasWatcher } from '../bundles/lab/components/class/saga';
import { courseCalendarSagaWatcher } from '../bundles/lab/components/course-calendar/saga';
import { courseViewSagaWatcher } from '../bundles/lab/components/course-view/saga';
import { emptyStateSagasWatcher } from '../bundles/lab/components/empty-state/saga';
import { examsResultsWatcher } from '../bundles/lab/components/exams-results/saga';
import { lessonEditorWidgetWatcher } from '../bundles/lab/components/lesson-editor-widget/saga';
import { librarySagasWatcher } from '../bundles/lab/components/library.store/saga';
import { newYearSagasWatcher } from '../bundles/lab/components/new-year-modal/saga';
import { teacherCertificatesWatcher } from '../bundles/lab/components/portfolio/saga';
import { quizEditorWatcher } from '../bundles/lab/components/quiz-editor/saga';
import { specCourseSagasWatcher } from '../bundles/lab/components/spec-course.store/saga';
import { teacherKPKsWatcher } from '../bundles/lab/components/teacher-kpks-page';
import { calendarPlanSagasWatcher } from '../store/calendar-plan/saga';
import { clessonResultsSagasWatcher } from '../store/clesson-results/saga';
import { mainPageSagasWatcher } from '../store/main-page/saga';

import commonWatchers from './common-watchers';

export default function* () {
    yield all([
        ...wizardWatchers,
        ...commonWatchers,
        lessonSagasWatcher(),
        deleteLessonSagasWatcher(),
        classesSagasWatcher(),
        classSagasWatcher(),
        courseViewSagaWatcher(),
        courseCalendarSagaWatcher(),
        userSagasWatcher(),
        certificateModalSagasWatcher(),
        studentsSagasWatcher(),
        acceptPersonalDataWatcher(),
        librarySagasWatcher(),
        coursesBySubjectsSagasWatcher(),
        newYearSagasWatcher(),
        problemsSagasWatcher(),
        prepLessonsSagasWatcher(),
        lessonViewSagasWatcher(),
        problemsViewSagasWatcher(),
        lessonEditorWidgetWatcher(),
        emptyStateSagasWatcher(),
        coursesTemplatesSagasWatcher(),
        teacherCoursesByClassSagasWatcher(),
        courseStatsSagasWatcher(),
        certificatesWatcher(),
        notificationsSagasWatcher(),
        themesSagasWatcher(),
        copyLessonSagaWatcher(),
        externalLmsSagasWatcher(),
        studentCLessonResultsSagaWatcher(),
        lessonViewSubscriptionModalSaga(),
        subscriptionsSagasWatcher(),
        diagnosticsSagasWatcher(),
        schoolFormSagasWatcher(),
        specCourseSagasWatcher(),
        referralCodeSagasWatcher(),
        resultsSagasWatcher(),
        awardsSagasWatcher(),
        assignmentSagasWatcher(),
        likesSagasWatcher(),
        stickersSagasWatcher(),
        teamBuilderSagasWatcher(),
        teacherCertificatesWatcher(),
        teacherKPKsWatcher(),
        clessonResultsSagasWatcher(),
        clessonsSagasWatcher(),
        quizEditorWatcher(),
        quizWatcher(),
        mainPageSagasWatcher(),
        calendarPlanSagasWatcher(),
        courseContainerWidgetSagasWatcher(),
        examsResultsWatcher(),
    ]);
}
